module.exports = __webpack_public_path__ + "static/git_logo-59a6979d4be1bebb30841252c38613b9.png";